import {
  ClipboardList,
  TrendingUp,
  Calculator,
  Presentation,
  Users,
  Monitor,
  Target,
  GraduationCap,
  Globe,
  DollarSign,
  type LucideIcon,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  ClipboardList,
  TrendingUp,
  Calculator,
  Presentation,
  Users,
  Monitor,
  Target,
  GraduationCap,
  Globe,
  DollarSign,
};

interface ServiceIconProps {
  name: string;
  className?: string;
}

export function ServiceIcon({ name, className = '' }: ServiceIconProps) {
  const Icon = iconMap[name];
  
  if (!Icon) {
    return null;
  }

  return <Icon className={className} />;
}